import { withStyles } from '@material-ui/core';

export default withStyles(() => ({
  fontDescriptionStyle: {
    fontSize: 14,
    fontWeight: 400,
    margin: 0,
  },
  card: {
    justifyContent: 'center',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  infoContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  managerIcon: {
    height: 40,
    width: 40,
    borderRadius: '100%',
  },
  personalInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  contactContainer: {
    display: 'flex',
    gap: '16px',
  },
  contactButton: {
    flex: 1,
    height: '32px',
    display: 'flex',
    border: '1px solid #D9D9D9',
    margin: 0,
    padding: '0',
    gap: '8px',
    '&:hover': {
      color: '#D9D9D9',
      backgroundColor: '#0D2772',
      opacity: 1,
      '& img': {
        filter: 'invert(1)',
      },
    },
  },
  icon: {
    width: '17px',
    marginRight: '8px',
  },
  whatsappLink: {
    width: '50%',
  },
}));
